<style>
div#refinance-liens {
  width: 100% !important;
}

.lien-item-container {
  position: relative !important;
  min-height: 80px;
}

@media screen and (max-width: 1296px) {
  .lien-item-container {
    min-height: 125px;
  }
}

@media screen and (max-width: 768px) {
  .lien-item-container {
    min-height: 110px;
  }
}

@media screen and (max-width: 503px) {
  .lien-item-container {
    min-height: 134px;
  }
}

@media screen and (max-width: 371px) {
  .lien-item-container {
    min-height: 158px;
  }
}

@media screen and (max-width: 327px) {
  .lien-item-container {
    min-height: 182px;
  }
}

.lien-item-container > span {
  display: -webkit-box;
  float: right;
  width: calc(100% - 40px);
}

.lien-item-container > span > div {
  width: 100%;
}

.remove-item-btn {
  position: absolute;
}

.payoff-checkbox {
  line-height: 38px;
}

.payoff-checkbox > .field-wrap {
  float: left;
}

.payoff-checkbox > .field-wrap > input[type="checkbox"] {
  margin-top: 12px;
  margin-left: 0px;
  margin-right: 12px;
}

.liens {
  margin-left: 15px;
  border-left: 2px solid #1d87b9;
  padding-left: 10px;
}
</style>

<template>
  <b-row>
    <b-col
      :lg="6" :offset-lg="3"
      :md="8" :offset-md="2"
    >
     <vue-form-generator
        :schema="schema"
        :model="form"
        :options="formOptions"
        ref="refinanceForm"
      ></vue-form-generator>
    </b-col>
  </b-row>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import schemaDefinition from './schema';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      schema: schemaDefinition.schema,
      formOptions: schemaDefinition.formOptions,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/refinance/RefinanceSection.vue